import React from "react";
import {
  Box,
  Toolbar,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Home } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

const Sidebar = ({ menuItems = [], user, onNavigate, mobileOpen, onClose }) => {
  const location = useLocation();

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Toolbar sx={{ background: "var(--primary-gradient)", color: "white" }}>
        <Home sx={{ mr: 2 }} />
        <Typography variant="h5" noWrap component="div" fontWeight="bold">
          Hostly Inn
        </Typography>
      </Toolbar>

      <Box sx={{ p: 2, backgroundColor: "var(--surface-2)" }}>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Hostly Inn Management System
        </Typography>
        <Typography variant="caption" color="text.secondary" textAlign="center" display="block">
          Welcome, {user?.name}
        </Typography>
      </Box>

      <Divider />

      <List sx={{ flexGrow: 1, px: 1 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
            <Tooltip title={item.description} placement="right">
              <ListItemButton
                selected={location.pathname === item.path}
                onClick={() => {
                  onNavigate(item.path);
                  if (mobileOpen && onClose) onClose();
                }}
                sx={{
                  borderRadius: 2,
                  mx: 1,
                  "&.Mui-selected": {
                    backgroundColor: "primary.main",
                    color: "white",
                    "&:hover": { backgroundColor: "primary.dark" },
                    "& .MuiListItemIcon-root": { color: "white" },
                  },
                  "&:hover": {
                    backgroundColor: "primary.light",
                    color: "white",
                    "& .MuiListItemIcon-root": { color: "white" },
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.text}
                  secondary={!location.pathname.includes(item.path) ? item.description : null}
                  secondaryTypographyProps={{ variant: "caption", sx: { color: "inherit", opacity: 0.7 } }}
                />
              </ListItemButton>
            </Tooltip>
          </ListItem>
        ))}
      </List>

      <Divider />
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography variant="caption" color="text.secondary">Role: {user?.role?.toUpperCase()}</Typography>
        {user?.room && (
          <Typography variant="caption" color="text.secondary" display="block">Room: {user.room.roomNumber}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default Sidebar;
